<form>
  <div class="w-3/4" hlmFieldGroup>
    <fieldset hlmFieldSet>
      <legend hlmFieldLegend>4. Productions</legend>
      <p hlmFieldDescription>Les productions sont issues des aptitudes sélectionnées à l’étape 2.</p>

      <div class="gap-xxs flex flex-col">
        <label hlmLabel>Sélectionnez les productions de l’activité</label>
        @if (formService().toutesLesAptitudes().length < 1) {
          <app-alerte
            title="Veuillez sélectionner une aptitude à l'étape 2."
            message="Vous devez d'abord sélectionner au moins une aptitude à l'étape 2 pour pouvoir sélectionner des productions."
          />
        }

        @for (item of productions() | trierPar: 'nom'; track item.id; let idx = $index) {
          <div class="gap-xs flex items-center">
            <hlm-checkbox
              [id]="'interrelation-' + idx"
              [checked]="isChecked(item.id)"
              [disabled]="formControl.disabled"
              (checkedChange)="onCheckboxChange($event, item)"
            />
            <label [for]="'interrelation-' + idx">
              <span class="component-medium-medium text-components-content-neutral-secondary">
                {{ item.nom }}
              </span>
            </label>
          </div>
        } @empty {
          <app-alerte
            title="Les aptitudes sélectionnées ne possèdent pas de productions."
            message="Veuillez passer cette étape. Ça ne vous gênera pas pour publier l’activité."
          />
        }
      </div>
    </fieldset>
  </div>
</form>
